import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

type TenantRole = {
  id: string;
  name: string;
};

type TenantRoleIndexResponse = TenantRole[];

export const tenantRoleApiClient = {
  index: async (): Promise<ApiResult<TenantRoleIndexResponse>> => {
    return await axiosClient.get('/tenant/tenant-roles');
  },
};
